import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Logo from 'components/atoms/Logo'
import FormResult from 'components/organisms/FormResult'

const styles = theme => ({
  root: {
    maxWidth: 350,
    display: 'flex',
    margin: '0 auto',
    minHeight: '100vh',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      maxWidth: 450,
    },
  },
  content: {
    textAlign: 'center',
    padding: `0 ${theme.spacing(2)}px`,
  },
  logo: {
    marginBottom: theme.spacing(6),
  },
})

const TrapInviteSuccess = ({ classes }) => (
  <div className={classes.root}>
    <Logo className={classes.logo} />
    <div className={classes.content}>
      <FormResult
        hideButton
        heading="Sweet as! You've accepted the invitation"
        subHeading="You can view your shared trap on your Goodnature Chirp account. Simply open the app to see all your trap activity."
      />
    </div>
  </div>
)

TrapInviteSuccess.propTypes = {
  classes: PropTypes.object,
}

export default withStyles(styles)(TrapInviteSuccess)



// WEBPACK FOOTER //
// ./src/components/organisms/TrapInviteSuccess.js